import "core-js/modules/es.string.search";
import runOnEnter from 'routes/helpers/runOnEnter';
import requireLoggedInSaga from 'routes/helpers/requireLoggedIn';
import requireMembershipSaga from 'routes/helpers/requireMembershipStatus';
import { memberStatus } from 'enums/memberStatus';
import { setApplePayAvailable } from 'helpers/storage';
import { checkWinbackOfferPermissionSaga } from './Rejoin.saga'; // polyfill webpack require.ensure

if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export var RejoinRoute = function RejoinRoute(store, client) {
  var requireLoggedIn = function requireLoggedIn(nextState, replaceState, cb) {
    return store.runSagaOnce(requireLoggedInSaga, nextState, replaceState).done.then(cb, cb);
  };

  var requireChurned = function requireChurned(nextState, replaceState, cb) {
    return store.runSagaOnce(requireMembershipSaga, client, replaceState, [memberStatus('CANCELLED')]).done.then(cb, cb);
  };

  var requireEligible = function requireEligible(nextState, replaceState, cb) {
    return store.runSagaOnce(checkWinbackOfferPermissionSaga, client, replaceState, null, "/rejoin/welcome-back".concat(nextState.location.search)).done.then(cb, cb);
  };

  var checkApplePaySupport = function checkApplePaySupport(query) {
    var applePayAvailable = !!(query.webview && query.apple_pay_available);
    setApplePayAvailable(applePayAvailable); // Since used in-app webviews, no need to expire the storage
  };

  return {
    path: 'rejoin',
    onEnter: function onEnter(nextState, replaceState, cb) {
      requireChurned(nextState, replaceState, cb);
      checkApplePaySupport(nextState.location.query);
    },
    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        callback(null, {
          // only allow
          // - logged in + churned + eligible
          component: require('containers/CmsPage/CmsPage').CmsPage,
          onEnter: runOnEnter(requireLoggedIn, requireEligible)
        });
      }, 'rejoin');
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function (require) {
        callback(null, [{
          // only allow
          // - logged in + churned
          path: 'welcome-back',
          component: require('containers/CmsPage/CmsPage').CmsPage,
          onEnter: runOnEnter(requireLoggedIn)
        }, {
          // allow
          // - non-logged in
          // - logged in + churned + eligible
          path: '*',
          component: require('containers/CmsPage/CmsPage').CmsPage,
          onEnter: requireEligible
        }]);
      }, 'rejoin');
    }
  };
};